import { render, staticRenderFns } from "./people-add.vue?vue&type=template&id=af5433c2&scoped=true&"
import script from "./people-add.vue?vue&type=script&lang=js&"
export * from "./people-add.vue?vue&type=script&lang=js&"
import style0 from "./people-add.vue?vue&type=style&index=0&id=af5433c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5433c2",
  null
  
)

export default component.exports